// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__38mUI","buttons":"SendReceipts_buttons__YtNrz","email":"SendReceipts_email__KRj5W","bookApptTitle":"SendReceipts_bookApptTitle__uYBJ_"};